var map = {
	"./1.jpeg": 9200,
	"./2.jpeg": 513,
	"./3.jpeg": 3114,
	"./4.jpeg": 9483,
	"./5.jpeg": 6740,
	"./6.jpeg": 661,
	"./Alma-Suite-BnB-Anzio-Camera-1.jpeg": 8928,
	"./Alma-Suite-BnB-Anzio-Camera-10.jpeg": 736,
	"./Alma-Suite-BnB-Anzio-Camera-2.jpeg": 7217,
	"./Alma-Suite-BnB-Anzio-Camera-3.jpeg": 4266,
	"./Alma-Suite-BnB-Anzio-Camera-4.jpeg": 2363,
	"./Alma-Suite-BnB-Anzio-Camera-5.jpeg": 9620,
	"./Alma-Suite-BnB-Anzio-Camera-6.jpeg": 6613,
	"./Alma-Suite-BnB-Anzio-Camera-7.jpeg": 1054,
	"./Alma-Suite-BnB-Anzio-Camera-8.jpeg": 7167,
	"./Alma-Suite-BnB-Anzio-Camera-9.jpeg": 5624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6631;